import React from 'react';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type Child = {
  value: string,
  label: React.ReactNode,
  children: React.ReactNode,
};

type Props = {
  size?: string,
  active: string,
  children: Array<Child>,
  onRequestChange: { (value: string): void },
};

const Tabs = ({
  size,
  active,
  children,
  onRequestChange,
}: Props) => {
  if (!children) return null;

  const items = Array.isArray(children)
    ? children.filter(c => c.$$typeof) // only react element's
    : [children];
  return (
    <Flex
      column
      width="100%"
      spacing={10}
    >
      <Flex
        width="100%"
        spacing={15}
        noPrint
      >
        {items.map(({ props }: Child) => (
          <S.Tab
            key={props.label}
            size={size}
            active={active?.toLowerCase() === props.value?.toLowerCase()}
            onClick={() => {
              onRequestChange(props.value);
            }}
          >
            {props.label}
          </S.Tab>
        ))}
      </Flex>
      <Flex width="100%">
        {items.map((child) => {
          if (child.props.value?.toLowerCase() !== active?.toLowerCase()) return undefined;
          return child;
        })}
      </Flex>
    </Flex>
  );
};

Tabs.defaultProps = {
  size: 'small',
};

export default Tabs;
